import React from 'react';
export function Bonuses() {
  const bonuses = [{
    number: 1,
    title: '10 Meriendas Anti-Ansiedad',
    description: 'Para esos momentos entre comidas donde todo puede descarrilar.',
    image: 'https://cdn.magicpatterns.com/uploads/ct64NwuRGmQizLukH8dpyn/BONUS_1.png'
  }, {
    number: 2,
    title: 'Guiones de 12 Frases para la Cena',
    description: 'Qué decir (y qué no) cuando la situación se pone tensa.',
    image: 'https://cdn.magicpatterns.com/uploads/9RaJgJtiWR3n4ZDiZHePV2/BONUS_2.png'
  }, {
    number: 3,
    title: 'Puentes Favoritos de Nuestra Casa (imprimible)',
    description: 'Para pegar en la heladera y tener siempre a mano.',
    image: 'https://cdn.magicpatterns.com/uploads/seQ12AL6jDJUKvm8WuGnTr/BONUS_3.png'
  }];
  return <section className="py-16 md:py-24 px-4 bg-[#FDFBF9]" data-id="element-34">
      <div className="max-w-6xl mx-auto" data-id="element-35">
        <div className="text-center mb-12" data-id="element-36">
          <h2 className="text-3xl md:text-4xl font-bold text-[#2E2E2E] mb-4" data-id="element-37">
            Además, te llevás 3 bonos
          </h2>
          <p className="text-lg text-[#2E2E2E]/70" data-id="element-38">
            PDFs separados incluidos con tu compra
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-39">
          {bonuses.map(bonus => <div key={bonus.number} className="bg-[#F6EEDC] rounded-xl overflow-hidden border border-[#2E2E2E]/5 shadow-sm" data-id="element-40">
              <div className="aspect-[4/3] overflow-hidden" data-id="element-41">
                <img src={bonus.image} alt={bonus.title} className="w-full h-full object-cover" data-id="element-42" />
              </div>
              <div className="p-6" data-id="element-43">
                <div className="inline-flex items-center justify-center w-8 h-8 bg-[#E0435A] text-white rounded-full text-sm font-bold mb-3" data-id="element-44">
                  {bonus.number}
                </div>
                <h3 className="text-lg font-bold text-[#2E2E2E] mb-2" data-id="element-45">
                  {bonus.title}
                </h3>
                <p className="text-[#2E2E2E]/70 text-sm leading-relaxed" data-id="element-46">
                  {bonus.description}
                </p>
              </div>
            </div>)}
        </div>

        <p className="text-center text-[#2E2E2E]/60 text-sm mt-8" data-id="element-47">
          Se descargan junto con el ebook.
        </p>
      </div>
    </section>;
}